import React, { createContext, useState, useCallback, useContext, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import { ToastContext } from './ToastContext';

export const CategoryContext = createContext(null);

export const CategoryProvider = ({ children }) => {
  const { apiFetch, isAuthenticated } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = useCallback(async () => {
    if (!isAuthenticated) return;
    setLoading(true);
    try {
      const res = await apiFetch('/api/categories');
      if (res.ok) {
        const data = await res.json();
        setCategories(data);
      }
    } catch (err) {
      console.error('Failed to fetch categories:', err);
      showToast('Kategorien konnten nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  }, [apiFetch, isAuthenticated, showToast]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const value = {
    categories,
    loading,
    refetchCategories: fetchCategories
  };

  return (
    <CategoryContext.Provider value={value}>
      {children}
    </CategoryContext.Provider>
  );
};
